import styled from 'styled-components'

export const StyledInputSelectOperatorWrapper = styled.div`
    width: max-content;
    min-width: 240px;
`
